export { MessagesList } from "./BaseChat";
export { MobileChatAgentHeader, MobileChatFrame } from "./MobileChatFrame";
export { TransparentFadeFrame } from "./TransparentFadeFrame";
export {
  userBubbleRootVariants,
  userBubbleBackgroundVariants,
  userStaticBubbleVariants,
  assistantElevatedBubbleInlineStyle,
  assistantBubbleRootVariants,
  assistantBubbleBackgroundVariants,
  assistantStaticBubbleVariants,
} from "./styles";
export type { AssistantStaticBubbleVariantProps, UserStaticBubbleVariantProps } from "./styles";
